import { ref } from "vue";
import LlListItem from "@/components/LlListItem.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import LlSwitch from "@/components/LlSwitch.vue";
import { useDistributionStore } from "../store/useDistributionStore";
import { useDistributionNavigationStore } from "../store/useDistributionNavigationStore";
import { useUpdateDistributionStore } from "../store/useUpdateDistributionStore";
import LlSelect from '@/components/LlSelect.vue';
import UpdateDistributionModal from "./UpdateDistributionModal.vue";
import updatePaymentArray from "./updatePayment";
export default {
  props: {
    transactions: {
      type: Object,
      required: true
    },
    me: {
      type: Object,
      required: true
    }
  },
  name: "AssignDistributions",
  components: {
    UpdateDistributionModal,
    LlListItem,
    LlSecondaryButton,
    LlSelect,
    LlSwitch
  },
  setup(props) {
    const isAssign = ref(false);
    const distributionId = ref("");
    const distributionStore = useDistributionStore();
    const updateDistributionStore = useUpdateDistributionStore();
    const distributionNavigationStore = useDistributionNavigationStore();
    function updatePayment() {
      const {
        unItemiziseDistributions,
        shareDistribution,
        originationDistribution,
        responsibleDistribution,
        referralDistribution,
        expensesDistribution
      } = updateDistributionStore;
      const paymets = updatePaymentArray(props.transactions, isAssign.value, unItemiziseDistributions, shareDistribution, originationDistribution, responsibleDistribution, referralDistribution, expensesDistribution);
      distributionStore.distributionPayments(paymets);
      distributionNavigationStore.toggleAssignDestributionModal(false);
    }
    function unItemiziseDistributionsChange(distributionId) {
      updateDistributionStore.unItemiziseDistributions = distributionId;
    }
    function shareChange(distributionId) {
      updateDistributionStore.shareDistribution = {
        share: true,
        distributionId
      };
    }
    function originationChange(distributionId) {
      updateDistributionStore.originationDistribution = {
        origination: true,
        distributionId
      };
    }
    function responsibleChange(distributionId) {
      updateDistributionStore.responsibleDistribution = {
        responsible: true,
        distributionId
      };
    }
    function referralChange(distributionId) {
      updateDistributionStore.referralDistribution = {
        referral: true,
        distributionId
      };
    }
    function expensesChange(distributionId) {
      updateDistributionStore.expensesDistribution = {
        expenses: true,
        distributionId
      };
    }
    return {
      isAssign,
      distributionStore,
      updatePayment,
      updateDistributionStore,
      distributionId,
      unItemiziseDistributionsChange,
      shareChange,
      originationChange,
      responsibleChange,
      referralChange,
      expensesChange,
      distributionNavigationStore
    };
  }
};